module.exports = `{
  "method": "tools/call",
  "params": {
    "name": "forms-public_create_form",
    "arguments": {
      "title": "Lead Qualification Home Page",
      "workspace_id": "marketing team"
    }
  }
}`
